/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const CaretUpIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path d="M11.21 7.136a1 1 0 0 1 1.58 0l6.524 8.64c.465.615.005 1.474-.789 1.474H5.475c-.794 0-1.254-.86-.79-1.474z" /></svg>;
};
export default CaretUpIcon;